import { PatientDetails } from '../types';
import { verifyNhsLoginApi } from '../services/nhs.service';
import { fetchAuthenticatedPatientDetailsApi } from '../services/session.service';

type UseVerifyNhsLoginDeps = {
  code: string;
  csrfToken: string;
  setApiLoading: () => void;
  setApiDone: () => void;
  setIsValidPatient: (value: boolean) => void;
  setIsVerified?: (value: boolean) => void;
  setIsNhsVerified?: (value: boolean) => void;
  setPatientDetails?: (value: PatientDetails) => void;
};

type VerifyNhsLoginResult = {
  ok: boolean;
};

export function useVerifyNhsLogin(deps: UseVerifyNhsLoginDeps) {
  return async function verify(): Promise<VerifyNhsLoginResult> {
    deps.setApiLoading();

    const result = await verifyNhsLoginApi(deps.code);

    deps.setApiDone();

    if (!result.ok) {
      deps.setIsValidPatient(false);
      deps.setIsNhsVerified(false);
      console.error('useVerifyNhsLogin error', result);
      return { ok: false }; // or map to your result shape
    }

    deps.setIsNhsVerified(true);
    const patientDetailsResult: { patientDetails: PatientDetails } | { ok: boolean } =
      await fetchAuthenticatedPatientDetailsApi();
    if ('patientDetails' in patientDetailsResult) {
      deps.setPatientDetails(patientDetailsResult.patientDetails);
      deps.setIsValidPatient(true);
    }

    // TODO: add GET patient details endpoint (Session will allow return)
    return {
      ok: true,
    };
  };
}
